import { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import { Table, Button, TableFilterModel } from 'design-library';

import { IProject } from 'common/models';
import { getCurrencyFormat, getDateFormat } from 'common/utils';
import { ProjectStatusEnum, getEnumKeys } from 'common/enums';
import { useProjects } from 'admin/hooks';
import ProjectSubmissionDetailsModal from './ProjectSubmissionDetailsModal';

export const ProjectManagement = () => {
  const [selectedProject, setSelectedProject] = useState<IProject | null>(null);

  const {
    isLoadingProjects,
    projectsResults,
    paginationModel,
    setPaginationModel,
    setQueryOptions,
  } = useProjects();

  const getFormattedRows = (projects: IProject[]) =>
    projects.map((project) => ({
      ...project,
      endDate: getDateFormat(project.endDate),
      price: getCurrencyFormat(project.price),
      startDate: getDateFormat(project.startDate),
      status: getEnumKeys(ProjectStatusEnum)[project.status],
    }));

  const onFilterChange = useCallback(
    (filterModel: TableFilterModel) => {
      setQueryOptions(
        filterModel.items.reduce(
          (acc, item) =>
            item.value ? { ...acc, [item.field]: item.value } : acc,
          {}
        )
      );
    },
    [setQueryOptions]
  );

  return (
    <Box px={4}>
      <Table
        columns={[
          {
            field: 'projectName',
            headerName: 'Project Name',
            width: 250,
          },
          {
            align: 'center',
            field: 'hirerName',
            headerAlign: 'center',
            headerName: 'Hirer Name',
            width: 210,
          },

          {
            align: 'center',
            field: 'startDate',
            filterable: false,
            headerAlign: 'center',
            headerName: 'Start Date',
            width: 110,
          },
          {
            align: 'center',
            field: 'endDate',
            filterable: false,
            headerAlign: 'center',
            headerName: 'End Date',
            width: 100,
          },
          {
            align: 'right',
            field: 'price',
            filterable: false,
            headerAlign: 'right',
            headerName: 'Price',
            width: 130,
          },
          {
            align: 'center',
            field: 'expertName',
            filterable: false,
            headerAlign: 'center',
            headerName: 'Expert',
            width: 210,
          },
          {
            align: 'center',
            field: 'status',
            headerAlign: 'center',
            headerName: 'Status',
            width: 100,
          },
          {
            align: 'center',
            field: 'action',
            filterable: false,
            headerAlign: 'center',
            headerName: 'Action',
            renderCell: (params) => (
              <Button
                disabled={params.row.status === 'Ongoing'}
                size="small"
                onClick={() => setSelectedProject(params.row as IProject)}
              >
                View
              </Button>
            ),
            width: 200,
          },
        ]}
        loading={isLoadingProjects}
        paginationMode="server"
        onPaginationModelChange={setPaginationModel}
        paginationModel={paginationModel}
        pageSizeOptions={[paginationModel.pageSize]}
        rowCount={projectsResults.total}
        rows={getFormattedRows(projectsResults.data)}
        showToolbar
        slots={
          {
            // noRowsOverlay: () => <BidTableEmptyState />,
          }
        }
        filterMode="server"
        onFilterModelChange={onFilterChange}
      />
      {selectedProject && (
        <ProjectSubmissionDetailsModal
          selectedProject={selectedProject}
          isShown
          onCancel={() => setSelectedProject(null)}
        />
      )}
    </Box>
  );
};
